/* eslint-disable global-require */
// Single facade to the wam API for testing purposes.
import wam from '@tcc/wam';
import { shouldUseMocks, getWamMockFile } from './mocks';
import { queryParam } from './queryString';

export function getUserData() {
  // This helps us mock proxy & self-proxy behavior in the local browser
  if (shouldUseMocks()) {
    const f = getWamMockFile();
    // eslint-disable-next-line import/no-dynamic-require
    const mockFile = require(`../mocks/wam/${f}`);
    return mockFile;
  }
  return wam.getUserData();
}

/**
 * Wrapper wam in a Promise
 * @return {Promise}
 */
export default function auth() {
  const f = getWamMockFile();
    // eslint-disable-next-line import/no-dynamic-require, global-require
  const currentUser = shouldUseMocks () ? require(`../mocks/wam/${f}`) : wam.getUserData();
  const userId = parseInt(queryParam('client-id'), 10);
  const isProxying = Boolean(userId && currentUser.clientId !== userId);
  const user = {
    isProxying,
    id: isProxying ? userId : undefined,
  };

  if (shouldUseMocks()) {
    return Promise.resolve({auth: { currentUser, user }});
  }

  return new Promise((resolve, reject) => {
    wam.on('authenticated', () => {
      resolve({auth: { currentUser, user }});
    });

    wam.on('error', (e) => {
      wam.reAuthenticate();
      reject(e);
    });

    wam.authenticate();
  });
}
